export const SET_MESSAGE = "SET_MESSAGE";
export const SET_MESSAGE_REQUESTED = "export const ";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const CLEAR_MESSAGE_REQUESTED = "CLEAR_MESSAGE_REQUESTED";
